Jelly.Actions.Clean_Characters = function(Parameters) {
	var $Trim_Element = $("#" + Parameters.Namespace + "_Value");
	$Trim_Element.val($Trim_Element.val().replace(Parameters.Restrict_Characters_Regex, ''));
};